import React, { useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "../../../store";
import { APIState } from "../../../store/API/types";
import { authDuoSuccess, cancelAuth } from "../../../store/API/actions";
import AuthBtnsComponent from "../AuthBtnComponent";

// @ts-ignore
import DuoWebSDK from 'duo_web_sdk';

const AuthDuoComponent = () => {
  const dispatch = useDispatch();
  const {duoHost, sigRequest} = useSelector<ApplicationState, APIState>(state => state.API);

  const handle2FAComplete = (form: any) => {
    const sigResponse = form.sig_response.value;
    dispatch(authDuoSuccess(sigResponse));
  }

  const handleCancelAuth = () => {
    dispatch(cancelAuth());
  }

  useEffect(() => {
    DuoWebSDK.init({
      iframe: "duo_iframe",
      host: duoHost,
      sig_request: sigRequest,
      submit_callback: handle2FAComplete,
    });
  }, []);

  return (
    <div className='auth-form-wrapper duo-wrapper'>
      <iframe id='duo_iframe' title='Duo iframe'/>
      <AuthBtnsComponent oncancel={handleCancelAuth} />
    </div>
  );
}

export default AuthDuoComponent;